import { Vehicle } from '../../../../sharedComponents/common.types';
import { DetailsTable } from '../../../../sharedComponents/sidebar/DetailsTable';
import { DetailsTableRow } from '../../../../sharedComponents/sidebar/DetailsTableRow';
import { getShipmentTableData } from './ShipmentDetailsRows';

type ShipmentDetailsTableProps = {
    vehicle: Vehicle;
    serviceKey: string | undefined;
    displayServiceKey: boolean;
};

export const ShipmentDetailsTable = ({ vehicle, serviceKey, displayServiceKey }: ShipmentDetailsTableProps) => {
    const shipmentTableData = getShipmentTableData(vehicle, serviceKey, displayServiceKey);
    return (
        <DetailsTable>
            {shipmentTableData.map(({ messageId, value }, index) => (
                <DetailsTableRow key={index} messageId={messageId} value={value} />
            ))}
        </DetailsTable>
    );
};
